import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { Empresa } from 'src/app/empresa/interfaces/empresa.interface';
import { RegistroService } from 'src/app/registro.service';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class NotificacionserviceService {
    apiSiriUrl = environment.apiSiriUrl;
    constructor(
        private http: HttpClient,
        private registroService: RegistroService
    ) {}

    postEmailService(mensaje: any) {
        const url = `${this.apiSiriUrl}envio`;
        return this.http
            .post<any>(url, mensaje)
            .pipe(catchError(this.handleErrorResponse));
    }

    /* Datos de empresa para enviar*/
    getEmpresaByNit(): Observable<Empresa | undefined> {
        const url = `${this.apiSiriUrl}agente-vigilado/${this.registroService.empresaSelected}`;
        return this.http.get<Empresa>(url);
    }

    private handleErrorResponse(error: HttpErrorResponse) {
        console.error(error.error.message);
        return throwError(error.error.message);
    }
}
